import React from 'react';
import './About.css';

const BOWL_IMAGES = [
  '/images/bowl-1.png',
  '/images/bowl-2.png',
  '/images/bowl-3.png',
  '/images/bowl-4.png',
  '/images/bowl-5.png',
];

const EDGE_BOWLS = [
  { side: 'left', img: 0, size: 92, top: 64, inset: -18, rotate: -8 },
  { side: 'left', img: 2, size: 108, top: 248, inset: 28, rotate: 6 },
  { side: 'left', img: 4, size: 120, top: 406, inset: 66, rotate: -5 },
  { side: 'left', img: 1, size: 118, top: 590, inset: -12, rotate: 9 },
  { side: 'left', img: 3, size: 136, top: 738, inset: 28, rotate: -7 },
  { side: 'left', img: 0, size: 110, top: 918, inset: 58, rotate: 5 },
  { side: 'left', img: 2, size: 82, top: 1072, inset: -18, rotate: -8 },
  { side: 'left', img: 4, size: 126, top: 1256, inset: 28, rotate: 6 },
  { side: 'left', img: 1, size: 92, top: 1414, inset: 66, rotate: -5 },
  { side: 'left', img: 3, size: 108, top: 1598, inset: -12, rotate: 9 },
  { side: 'left', img: 0, size: 120, top: 1746, inset: 28, rotate: -7 },
  { side: 'left', img: 2, size: 118, top: 1926, inset: 58, rotate: 5 },
  { side: 'left', img: 4, size: 136, top: 2080, inset: -18, rotate: -8 },
  { side: 'left', img: 1, size: 110, top: 2264, inset: 28, rotate: 6 },
  { side: 'left', img: 3, size: 82, top: 2422, inset: 66, rotate: -5 },
  { side: 'left', img: 0, size: 126, top: 2606, inset: -12, rotate: 9 },
  { side: 'left', img: 2, size: 92, top: 2754, inset: 28, rotate: -7 },
  { side: 'left', img: 4, size: 108, top: 2934, inset: 58, rotate: 5 },
  { side: 'left', img: 1, size: 120, top: 3088, inset: -18, rotate: -8 },
  { side: 'left', img: 3, size: 118, top: 3272, inset: 28, rotate: 6 },
  { side: 'left', img: 0, size: 136, top: 3430, inset: 66, rotate: -5 },
  { side: 'left', img: 2, size: 110, top: 3614, inset: -12, rotate: 9 },
  { side: 'right', img: 1, size: 84, top: 106, inset: -16, rotate: -5 },
  { side: 'right', img: 3, size: 118, top: 268, inset: 30, rotate: 9 },
  { side: 'right', img: 0, size: 98, top: 472, inset: 68, rotate: -7 },
  { side: 'right', img: 2, size: 132, top: 638, inset: -10, rotate: 5 },
  { side: 'right', img: 4, size: 110, top: 840, inset: 30, rotate: -8 },
  { side: 'right', img: 1, size: 140, top: 1004, inset: 60, rotate: 6 },
  { side: 'right', img: 3, size: 88, top: 1198, inset: -16, rotate: -5 },
  { side: 'right', img: 0, size: 124, top: 1360, inset: 30, rotate: 9 },
  { side: 'right', img: 2, size: 84, top: 1564, inset: 68, rotate: -7 },
  { side: 'right', img: 4, size: 118, top: 1730, inset: -10, rotate: 5 },
  { side: 'right', img: 1, size: 98, top: 1932, inset: 30, rotate: -8 },
  { side: 'right', img: 3, size: 132, top: 2096, inset: 60, rotate: 6 },
  { side: 'right', img: 0, size: 110, top: 2290, inset: -16, rotate: -5 },
  { side: 'right', img: 2, size: 140, top: 2452, inset: 30, rotate: 9 },
  { side: 'right', img: 4, size: 88, top: 2656, inset: 68, rotate: -7 },
  { side: 'right', img: 1, size: 124, top: 2822, inset: -10, rotate: 5 },
  { side: 'right', img: 3, size: 84, top: 3024, inset: 30, rotate: -8 },
  { side: 'right', img: 0, size: 118, top: 3188, inset: 60, rotate: 6 },
  { side: 'right', img: 2, size: 98, top: 3382, inset: -16, rotate: -5 },
  { side: 'right', img: 4, size: 132, top: 3544, inset: 30, rotate: 9 },
];


const BowlLayer = ({ bowls, layer_class_name }) => (
  <div className={`bowl-layer ${layer_class_name}`}>
    {bowls.map((bowl, i) => (
      <img
        key={i}
        src={BOWL_IMAGES[bowl.img]}
        alt=""
        className="bowl-decoration"
        style={{
          width: bowl.size,
          height: bowl.size,
          top: bowl.top,
          [bowl.side]: bowl.inset,
          '--bowl-rotate': `${bowl.rotate}deg`,
        }}
      />
    ))}
  </div>
);

const About = () => (
  <div className="about">
    <BowlLayer bowls={EDGE_BOWLS} layer_class_name="bowl-layer-edge" />

    <div className="about-content">
      <div className="about-headline">
        <h1 className="about-title">This is Jay</h1>
      </div>

      <div className="about-photo-block">
        <img
          src="/images/about-girlfriend.png"
          alt="Jay's girlfriend"
          className="about-photo"
        />
      </div>

      <div className="about-headline">
        <h2 className="about-subtitle">'s beautiful girlfriend</h2>
      </div>

      <div className="about-photo-block">
        <img
          src="/images/about-jay.png"
          alt="Jay working at the pottery wheel"
          className="about-photo"
        />
      </div>

      <div className="about-headline">
        <h1 className="about-title">This is Jay</h1>
      </div>

      <p className="about-text">
        Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay Jay
      </p>
    </div>
  </div>
);

export default About;
